import { injectable, inject } from 'inversify';
import { CommandHandler } from '@/app/tracking/api';
import { UpdateBookmarkTrackingCommand, UpdateBookmarkTrackingCommandPayload } from '../api';
import { BookmarkDataStore, BookmarkDataStoreSymbol } from './bookmark-data-store'

@injectable()
export class UpdateBookmarkTrackingCommandHandler implements CommandHandler<UpdateBookmarkTrackingCommand> {

  constructor(
    @inject(BookmarkDataStoreSymbol)
    private store: BookmarkDataStore) {
  }

  public async execute(command: UpdateBookmarkTrackingCommandPayload) {

    const bookmark = command.bookmark
    await this.store.update({
      sectionId: bookmark.sectionId
    })    
  }
}
